import React from 'react'
import styled from 'styled-components'
import { Formik, Field, Form } from 'formik'
import { Fetch } from 'react-request'
import TextInput from '../../../../../../TextInput'
import Button from '../../../../../../Button'
import CheckboxField from './CheckboxField'
import initialValues from './lib/initialValues'
import validationSchema from './lib/validationSchema'
import onSubmit from './lib/onSubmit'

const Container = styled.div`
  padding: 40px 20px;
  max-width: 450px;
  margin: 0 auto;
`

const LineContainer = styled.div`
  display: flex;
  justify-content: center;
`

export default ({ mainForm, handleSuccess }) => (
  <Fetch url={process.env.REACT_APP_ZAPIER_HOOK_URL} method='POST'>
    {({ doFetch, data, fetching }) => (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit(doFetch, mainForm, handleSuccess)}
      >
        {(form) => (
          <Form>
            <Container>
              <LineContainer>
                <Field name='email'>
                  {({ field }) => (
                    <TextInput
                      textAlign='left'
                      placeholder='your@email.com'
                      error={form.errors[field.name]}
                      {...field}
                    />
                  )}
                </Field>
                <Button small loading={fetching} type='submit'>
                  Get now
                </Button>
              </LineContainer>
              <CheckboxField />
            </Container>
          </Form>
        )}
      </Formik>
    )}
  </Fetch>
)
